if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  const registerLocalizationForm = () => {
    if (!window.Alpine) return;

    Alpine.data('xLocalizationForm', () => ({ 
      openCountry: false,
      loading: false,
      cachedResults: false,
      submit(value, input) {
        this.$el.closest("#localization_form").querySelector('#'+input).value = value;
        this.$el.closest("#localization_form").submit();
      },
      loadCountry(el) {
        if (this.cachedResults) {
          this.openCountry = true;
          return true
        }
        let countrySelector = el.closest(".country-selector");
        let optionEL = countrySelector.querySelector(".country-options");

        this.loading = true;
        fetch(window.Shopify.routes.root + '?section_id=country-selector')
        .then(reponse => {
          return reponse.text();
        })
        .then((response) => {
          const parser = new DOMParser();
          const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
          optionEL.innerHTML = content;
          this.cachedResults = true;
          this.openCountry = true;
        })
        .finally(() => {
          this.loading = false;
        })
      },
    }))
  };

  // Register normally when Alpine starts, or immediately if Alpine already started.
  if (window.Alpine) {
    registerLocalizationForm();
  } else {
    document.addEventListener('alpine:init', registerLocalizationForm, { once: true });
  }

  // Robust language-switch fallback. This bypasses Alpine timing issues and submits
  // Shopify's native localization form directly using the language_code hidden input.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.locale-options a.nav-link');
    if (!link) return;

    const expression = link.getAttribute('@click') || link.getAttribute('x-on:click') || '';
    const match = expression.match(/submit\('([^']+)'\s*,\s*'locale_selector'\)/);
    if (!match) return;

    const form = link.closest('form#localization_form');
    const input = form && form.querySelector('#locale_selector[name="language_code"]');
    if (!form || !input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = match[1];
    form.submit();
  }, true);
}
